import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state:{
        //存放的键值对就是所要管理的状态
        scrolled: 0,
        scrollnorm: 0,
        innerWidth:0,
    },
    mutations:{
        //es6语法，等同edit:funcion(){...}
        commitScrolled(state,num){
            state.scrolled = num;
        },
        commitScrollnorm(state,num){
            state.scrollnorm = num;
        },
        commitWidth(state,num){
            state.innerWidth = num;
        }
    }
})

export default store